function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icon_contact_email_bor");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u5173\\u4E8E\\u6211\\u4EEC",
  transform: "translate(-938.000000, -4685.000000)"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u6211\\u4EEC",
  transform: "translate(-2.000000, 4403.000000)"
}, React.createElement("g", {
  id: "Repeat-Group",
  transform: "translate(377.000000, 242.000000)"
}, React.createElement("g", {
  id: "template/card/contact",
  transform: "translate(408.000000, 0.000000)"
}, React.createElement("g", {
  id: "Group-2"
}, React.createElement("g", {
  transform: "translate(101.000000, 40.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(54.500000, 0.000000)"
}, React.createElement("g", {
  id: "icon/contact/phone"
}, React.createElement("g", {
  id: "icon/contact/email_bor"
}, React.createElement("g", null, React.createElement("path", {
  d: "M9.8,13 L38.7,13 C39.1418278,13 39.5,13.3581722 39.5,13.8 L39.5,33.7 C39.5,34.1418278 39.1418278,34.5 38.7,34.5 L9.8,34.5 C9.3581722,34.5 9,34.1418278 9,33.7 L9,13.8 C9,13.3581722 9.3581722,13 9.8,13 Z M10.6052632,14.9925926 L10.6052632,32.5074074 C10.6052632,32.7283213 10.7843493,32.9074074 11.0052632,32.9074074 L37.4947368,32.9074074 C37.7156507,32.9074074 37.8947368,32.7283213 37.8947368,32.5074074 L37.8947368,14.9925926 C37.8947368,14.7716787 37.7156507,14.5925926 37.4947368,14.5925926 L11.0052632,14.5925926 C10.7843493,14.5925926 10.6052632,14.7716787 10.6052632,14.9925926 Z",
  id: "Rectangle",
  fill: "currentColor",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M12.662306,17.8135198 L12.657819,17.8194718 C12.3982035,18.1638495 12.4669168,18.6534827 12.8112945,18.9130982 C12.8147873,18.9157313 12.8183021,18.918335 12.8218387,18.920909 L23.0292221,26.3502663 C23.3098439,26.5545145 23.6901561,26.5545145 23.9707779,26.3502663 L34.1781613,18.920909 C34.5268528,18.6671169 34.6037839,18.1787074 34.3499918,17.830016 C34.3474178,17.8264794 34.3448141,17.8229646 34.342181,17.8194718 L34.337694,17.8135198 C34.0748795,17.4648987 33.5810923,17.3913668 33.2281042,17.6482862 L23.735389,24.5574783 C23.595078,24.6596024 23.404922,24.6596024 23.264611,24.5574783 L13.7718958,17.6482862 C13.4189077,17.3913668 12.9251205,17.4648987 12.662306,17.8135198 Z",
  id: "Path",
  fill: "currentColor",
  fillRule: "nonzero"
}), React.createElement("g", {
  id: "empty"
}, React.createElement("rect", {
  x: 0,
  y: 0,
  width: 48,
  height: 48
})))))))))))));

var SvgContactIconEmail = function SvgContactIconEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "49px",
    height: "48px",
    viewBox: "0 0 49 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContactIconEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact_icon_email.d90c76d5.svg";
export { ForwardRef as ReactComponent };